import { useState } from "react";
import { Reveal } from "./Reveal";
import { TESTIMONIALS } from "@/data/business";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const Testimonials = () => {
  const [i, setI] = useState(0);
  const total = TESTIMONIALS.length;
  const next = () => setI((p) => (p + 1) % total);
  const prev = () => setI((p) => (p - 1 + total) % total);
  const t = TESTIMONIALS[i];

  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-24 sm:py-32 bg-[color:var(--nitc-bg-3)] relative overflow-hidden"
    >
      <div className="container-nitc">
        <Reveal className="max-w-3xl">
          <p className="text-eyebrow">In their words</p>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl font-semibold text-[color:var(--nitc-ink)] leading-[1.05] tracking-tight">
            What our clients say about working with us.
          </h2>
          <p className="mt-4 text-xs text-[color:var(--nitc-muted)] italic">
            Illustrative quotes representing long-standing client relationships.
          </p>
        </Reveal>

        <div className="mt-14 grid lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-9 relative min-h-[260px]">
            <AnimatePresence mode="wait">
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 18 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -18 }}
                transition={{ duration: 0.55, ease: [0.21, 0.47, 0.32, 0.98] }}
                data-testid="testimonial-card"
              >
                <blockquote className="font-display text-2xl sm:text-3xl lg:text-4xl leading-[1.25] text-[color:var(--nitc-ink)] font-medium tracking-tight">
                  “{t.quote}”
                </blockquote>
                <div className="mt-8 flex items-center gap-4">
                  <div className="h-12 w-12 rounded-full bg-[color:var(--nitc-accent)]/15 flex items-center justify-center font-display text-[color:var(--nitc-accent)] font-semibold">
                    {t.company[0]}
                  </div>
                  <div>
                    <p className="font-medium text-[color:var(--nitc-ink)]">{t.author}</p>
                    <p className="text-sm text-[color:var(--nitc-text)]">
                      {t.company} · <span className="text-[color:var(--nitc-muted)]">{t.tag}</span>
                    </p>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          <div className="lg:col-span-3 flex lg:flex-col gap-4 lg:items-end justify-between">
            <div className="flex items-center gap-3">
              <button
                onClick={prev}
                data-testid="testimonial-prev"
                aria-label="Previous testimonial"
                className="h-12 w-12 rounded-full border border-[color:var(--nitc-ink)]/15 hover:bg-[color:var(--nitc-accent)] hover:text-white hover:border-[color:var(--nitc-accent)] flex items-center justify-center transition-all"
              >
                <ChevronLeft className="h-5 w-5" />
              </button>
              <button
                onClick={next}
                data-testid="testimonial-next"
                aria-label="Next testimonial"
                className="h-12 w-12 rounded-full border border-[color:var(--nitc-ink)]/15 hover:bg-[color:var(--nitc-accent)] hover:text-white hover:border-[color:var(--nitc-accent)] flex items-center justify-center transition-all"
              >
                <ChevronRight className="h-5 w-5" />
              </button>
            </div>
            <p className="font-display text-[color:var(--nitc-muted)] text-sm">
              <span className="text-[color:var(--nitc-ink)] text-base font-medium">
                {String(i + 1).padStart(2, "0")}
              </span>
              {" / "}
              {String(total).padStart(2, "0")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
